<template>
    <v-row name="diagnostic-container" justify="center">
      <!-- Modal de carregamento da estrutura de dados - FORA da estrutura principal -->
      <v-dialog v-model="isUpdatingDataStructure" max-width="400" persistent>
        <v-card color="primary" dark>
          <v-card-text class="text-center pa-6">
            <v-progress-circular
              indeterminate
              size="64"
              width="6"
              color="white"
              class="mb-4"
            ></v-progress-circular>
            <div class="text-h6 mb-2">Atualizando Estrutura de Dados</div>
            <div class="text-body-1">{{ updatingDataStructureMessage }}</div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="openModal"
        fullscreen
        no-click-animation
        persistent
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card
          name="diagnostic-card"
        >
          <v-toolbar
            dark
            color="primary"
          >
            <v-btn
              icon
              dark
              @click="close()"
              :loading="is_loading"
              :disabled="is_loading"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ idDiagnostic ? 'Diagnóstico' : 'Nova Proposta' }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items >
              <v-btn
                dark
                text
                @click="save()"
                :loading="is_loading"
              >
                Salvar Rascunho
              </v-btn>
            </v-toolbar-items>
            <v-dialog v-model="is_loading" max-width="320" persistent>
              <v-list class="py-5" color="primary" elevation="12" rounded style="max-height: 400px; overflow-y: auto;">
                <v-list-item class="d-flex justify-space-between">
                  <div>
                    <span style="color: white; font-size: large;">Salvando Diagnóstico...</span>
                  </div>
                  <div>
                    <v-progress-circular color="#1A237E" indeterminate size="32" width="2"></v-progress-circular>
                  </div>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item v-for="(image, index) in savedImages" :key="index">
                  <v-list-item-content>
                    <v-list-item-title style="color: white;">
                      {{ image.name }} - 100%
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-dialog>
          </v-toolbar>
          <div
            name="diagnostic-tabs"
            style="
              padding-bottom: 72px;
              overflow-y: auto;
            "
          >

          <v-dialog
            v-model="dialogAlert"
            persistent
            max-width="500px"
          >    
      
          <v-card color="primary"> 
            <v-card-title style="color: white">
              <v-icon color="yellow darken-2" left>mdi-alert</v-icon>
              Aviso
              <v-spacer></v-spacer>            
            </v-card-title>
            <v-card-text style="color: white">    
              <div style="display: flex; align-items: center; margin-bottom: 10px;">
                <span style="font-weight: bold; font-size: 1.1em;">Resumo dos dados não salvos</span>
              </div>
              <div style="max-height: 220px; overflow-y: auto;" v-if="localStorageData">
                <!-- Tabela detalhada das soluções -->
                <div v-if="localStorageData.solutionList && localStorageData.hydrometerList.length > 0" style="margin-top: 15px;">
                  <div style="display: flex; align-items: center; margin-bottom: 10px;">
                    <span style="font-weight: bold; font-size: 1em;">Detalhes das Soluções:</span>
                  </div>
                  <v-simple-table dense style="background: transparent; color: white;">
                    <thead>
                      <tr>
                        <th>Local</th>
                        <th>Sub-local</th>
                        <th>Qtd</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(sol, idx) in localStorageData.solutionList.filter(sol => sol.isModified || sol.isDeleted)" :key="idx">
                        <td>{{ sol.local || '-' }}</td>
                        <td>{{ sol.sub_local || '-' }}</td>
                        <td>{{ sol.amountSolution || '-' }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </div>
                <div v-if="localStorageData.solutionList && localStorageData.solutionList.filter(sol => sol.isModified || sol.isDeleted).length > 0" style="margin-top: 15px;">
                  <div style="display: flex; align-items: center; margin-bottom: 10px;">
                    <span style="font-weight: bold; font-size: 1em;">Detalhes das Soluções:</span>
                  </div>
                  <v-simple-table dense style="background: transparent; color: white;">
                    <thead>
                      <tr>
                        <th>Local</th>
                        <th>Sub-local</th>
                        <th>Qtd</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(sol, idx) in localStorageData.solutionList.filter(sol => sol.isModified || sol.isDeleted)" :key="idx">
                        <td>{{ sol.local || '-' }}</td>
                        <td>{{ sol.sub_local || '-' }}</td>
                        <td>{{ sol.amountSolution || '-' }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </div>
              </div>
              <v-divider class="my-2"/>
              Existem informações que não foram salvas, deseja recuperar esses dados?
            </v-card-text>
            <v-card-actions >
              <v-spacer></v-spacer> 
              <v-btn
                color="white"
                text
                @click="getLocalStorageDiagnostic()"
              >
                Confirmar
              </v-btn>
              <v-btn
                color="white"
                text
                @click="cancelGetLocalStorageDiagnostic()"
              >
                Cancelar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="dialogConfirmDeleteLocal"
          persistent
          max-width="400px"
        >
          <v-card color="primary">
            <v-card-title style="color: white">
              <v-icon color="red lighten-2" left>mdi-alert</v-icon>
              Atenção
              <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text style="color: white">
              Se você prosseguir, os dados locais não salvos serão <b>permanentemente excluídos</b> e não poderão ser recuperados. Tem certeza que deseja continuar?
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="white" text @click="confirmDeleteLocal">Sim, excluir</v-btn>
              <v-btn color="white" text @click="cancelDeleteLocal">Voltar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
            <DiagnosticStepper 
              v-if="!is_loading && (idDiagnostic || id_diagnostic) && !isProposalOnlyMode"
              :steps="steps"
              @changeTab="nextTab"
            />
            
            <v-form 
              ref="diagnosticForm"
              v-model="isValidForm"
              lazy-validation
            >
              <div class="components-container" style="position: relative;">
                <CheckListTab 
                  ref="CheckListTab"
                  :show="visibleTabs['checklist']"
                  :param="diagnostic"
                  :desiredProposal="desiredProposal"
                  :projectId="idDiagnostic || ''"
                  :enableAddEvent="enableAddEvent"
                  :proposalType="proposalType"
                  @param:update="updateDiagnostic"
                  @validate="(status) => validateTab('checklist', status)"
                />
                <HistoricTab
                  :show="visibleTabs['historic']"
                  :param="diagnostic"
                  @param:update="updateDiagnostic"
                  @validate="(status) => validateTab('historic', status)"
                  :idProject="idDiagnostic || ''"
                />
              </div>
            </v-form>
          </div>
        </v-card>
      </v-dialog>
    </v-row>
</template>
  
<script>
import Diagnostic from "./Diagnostic.js";
export default Diagnostic;
</script>
  
<style scoped>
.components-container {
  position: relative; /* Necessário para posicionar o overlay */
  z-index: 0;
  padding: 16px; /* Espaçamento opcional */
  border: 1px solid #ccc; /* Opcional, para demarcar a área */
  border-radius: 8px; /* Opcional, para um layout mais limpo */
  background: white; /* Certifique-se de que o fundo seja visível */
}
</style>